.error-modal {
  $self: &;

  &__content {
    /* stylelint-disable-next-line selector-class-pattern */
    .error-modal__content-extra-padding {
      @include agl-ds-screen-size('medium') {
        padding-bottom: $space-06;
      }
    }

    display: flex;
    flex-flow: row;
    justify-content: space-between;
  }

  &__link {
    font-weight: $font-weight-semi-bold;
  }

  &__content-text-wrapper {
    padding-bottom: $space-03;

    @include agl-ds-screen-size('medium') {
      width: 62%;
      padding-bottom: 0;
    }
  }

  &__content-image-wrapper {
    display: none;
    max-height: 192px;
    max-width: 264px;

    @include agl-ds-screen-size('medium') {
      display: block;
      padding: 0 $space-04 $space-02 0;
    }

    @include agl-ds-screen-size('large') {
      padding: 0;
    }
  }

  &__button-wrapper {
    padding: $space-01 0 $space-02 0;

    @include agl-ds-screen-size('medium') {
      padding: 0;
      display: flex;
      justify-content: space-between;
    }
  }

  &__first-button-container {
    width: 100%;

    @include agl-ds-screen-size('medium') {
      width: 50%;
    }

    &--bottom-spacer {
      margin-bottom: $space-02;

      @include agl-ds-screen-size('medium') {
        margin-bottom: 0;
      }
    }
  }

  &__second-button-container {
    width: 100%;

    @include agl-ds-screen-size('medium') {
      width: 50%;
      display: flex;
      justify-content: flex-end;
    }
  }

  &__second-button {
    @include agl-ds-screen-size('medium') {
      max-width: 288px;
      width: 100%;
    }
  }

  &__liveperson {
    display: inline;
  }
}

.agl-ds-modal {
  &__content {
    min-height: 230px;
    overflow-y: hidden;
  }
}
